export const environment = {
  production: false,
  api_url: 'dev-as-bd.f2-tech.com'
};
